
import React, { useState, useRef } from "react";
import "./Foodbeveragespromotions.css";
import Campaigns from "./Campaigns";
import Promotiondashbord from './Promotiondashbord';
import CreateCampaign from './CreateCampaign';
import Campaignanlytics from './Campaignanlytics';
import Cuponsfiledata from './Cuponsfiledata';
import Foodaddsvideos from "./Foodaddsvideos";
import CampaignAnalytics from "./CampaignAnalytics";
import Couponsdata from "./Couponsdata";
import IncentivesPage from "./IncentivesPage.jsx"
/* ---------- Main Company Component ---------- */
const FoodPramotions = () => {
    const containerRef = useRef(null); // 👈 add this 

    const scrollToTop = () => {
        containerRef.current?.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    const tabs = [
        {
            id: 1,
            name: "CREATE CAMPAIGN",
            component: () => <CreateCampaign title="Create New Campaign" scrollToTop={scrollToTop} />,
        },

        {
            id: 2,
            name: "CAMPAIGNS",
            component: () => <Campaigns title="All Campaigns" />,
        },


        {
            id: 3,
            name: "ANALYTICS",
            component: () => <CampaignAnalytics title="Campaign Analytics" />,
        },
        {
            id: 4,
            name: "Digital Screens",
            component: () => <Foodaddsvideos title="DIGITAL" />,
        },
        {
            id: 5,
            name: "Coupons",
            component: () => <Couponsdata title="COUPONS" />,
        },
        {
            id: 6,
            name: "Incentives",
            component: () => <IncentivesPage title="Incentives" />,
        },
    ];

    const [activeTab, setActiveTab] = useState(tabs[0].id);
    const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

    return (
        <div className="company-container" ref={containerRef}>

            <style>{`
   /* Default (Mobile first) – kuch change nahi */
   .company-scroll-container {
     position: static;
     background: #fff;
   }

   .company-buttons-row {
     display: flex;
     // gap: 10px;
     flex-wrap: wrap;
   }

   .company-button {
     padding: 8px 16px;
     border: none;
     background: #f0f0f0;
     cursor: pointer;
     border-radius: 6px;
     white-space: nowrap;
   }

   .company-button.active {
     background: #e66d33;
     color: #fff;
   }

   /* ✅ Desktop / Laptop only */
   @media (min-width: 769px) {
     .company-scroll-container {
       position: sticky;
       top: 0;
       z-index: 100;
       padding: 10px 0;
     }
   }
 `}</style>

            <div className="company-scroll-container">
                <div className="company-buttons-row">
                    {tabs.map(tab => (
                        <button
                            key={tab.id}
                            className={`company-button ${activeTab === tab.id ? "active" : ""}`}
                            onClick={() => setActiveTab(tab.id)}
                        >
                            {tab.name}
                        </button>
                    ))}
                </div>
            </div>

            <div className="component-display">
                {ActiveComponent && <ActiveComponent />}
            </div>
        </div>
    );
};


export default FoodPramotions;




